import { Injectable } from "@angular/core";
import { NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class VegaModalConfig extends NgbModalConfig {

    constructor() {
        super();
        this.backdrop = 'static';
        this.keyboard = false;
        this.centered = true;
    }

}
